import { useState } from "react";
import { GlassCard } from './ui';
import { DEST_EMOJIS } from '../constants/formOptions';

export default function CommunityView({ communityTrips, reviews=[], myName="", personal, savedTrips=[], onShareSavedTrip, sharedTripIds=[], darkMode=false, t, onViewTrip, onDeleteTrip, onEditReview, onDeleteReview, authRequired=false }) {
  const dm = darkMode;
  const [likedIds, setLikedIds] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem("likedTrips") || "[]"); } catch(e) { return []; }
  });
  const [filterDest, setFilterDest] = useState("전체");
  const [reviewPage, setReviewPage] = useState(0);
  const [expandedReview, setExpandedReview] = useState(null);
  const [deletingTrip, setDeletingTrip] = useState(null);
  const REVIEWS_PER_PAGE = 5;

  const getEmoji = (dest) => {
    for(const [k,v] of Object.entries(DEST_EMOJIS)) { if(dest && dest.includes(k)) return v; }
    return "📍";
  };
  const COLORS = ["#F5A623","#4ECDC4","#E8935A","#7BB8F0","#8DD9C0"];
  const STARS = ["","★","★★","★★★","★★★★","★★★★★"];

  // TOP 5
  const destCount = {};
  communityTrips.forEach(tr => { destCount[tr.destination] = (destCount[tr.destination]||0)+1; });
  const top5 = Object.entries(destCount).sort((a,b)=>b[1]-a[1]).slice(0,5);

  const toggleLike = (id) => {
    const nl = likedIds.includes(id) ? likedIds.filter(x=>x!==id) : [...likedIds, id];
    setLikedIds(nl);
    try { sessionStorage.setItem("likedTrips", JSON.stringify(nl)); } catch(e) {}
  };

  const dests = ["전체", ...Object.keys(destCount)];
  const filtered = filterDest==="전체" ? communityTrips : communityTrips.filter(tr=>tr.destination&&tr.destination.includes(filterDest));

  const getMyReview = (trip) => reviews.find(r =>
    r.author === (myName||personal?.name) &&
    r.destination === trip.destination &&
    r.startDate === trip.startDate
  );

  return (
    <GlassCard className="animate-in">
      {/* 헤더 */}
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:20 }}>
        <div style={{ fontSize:28 }}>🌍</div>
        <div>
          <h2 style={{ fontSize:17, fontWeight:800, color:"var(--accent)" }}>{t.communityTitle}</h2>
          <p style={{ fontSize:11, color:dm?"rgba(226,232,240,0.70)":"rgba(51,65,85,0.65)" }}>{t.communityDesc}</p>
        </div>
      </div>

      {/* TOP 5 */}
      <div style={{ marginBottom:24 }}>
        <div style={{ fontSize:13, fontWeight:800, color:"var(--text)", marginBottom:12 }}>{t.top5Title}</div>
        {top5.length === 0 ? (
          <div style={{ padding:"16px", borderRadius:12, background:dm?"rgba(255,255,255,0.04)":"rgba(255,255,255,0.7)", textAlign:"center", fontSize:12, color:dm?"rgba(226,232,240,0.60)":"rgba(51,65,85,0.58)" }}>
            {authRequired ? "로그인하면 인기 여행지를 볼 수 있어요 🔒" : "아직 데이터가 쌓이는 중이에요 📊"}
          </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {top5.map(([dest,cnt],i) => (
              <div key={dest} onClick={()=>setFilterDest(dest)} style={{ display:"flex", alignItems:"center", gap:12, padding:"10px 14px", borderRadius:12, cursor:"pointer", background:i===0?dm?"rgba(129,140,248,0.15)":"rgba(238,242,255,0.95)":dm?"rgba(255,255,255,0.04)":"rgba(255,255,255,0.75)", border:`1px solid ${i===0?"var(--accent)":dm?"rgba(129,140,248,0.12)":"rgba(99,102,241,0.15)"}`, transition:"all 0.2s" }}>
                <div style={{ width:28, height:28, borderRadius:8, background:COLORS[i]||"#ccc", display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:900, color:"#fff", flexShrink:0 }}>{i+1}</div>
                <div style={{ flex:1 }}><span style={{ fontSize:13, fontWeight:800, color:i===0?"var(--accent)":"var(--text)" }}>{getEmoji(dest)} {dest}</span></div>
                <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end" }}>
                  <div style={{ fontSize:11, fontWeight:700, color:"var(--accent)" }}>{cnt}개 일정</div>
                  <div style={{ width:50, height:4, borderRadius:2, background:dm?"rgba(255,255,255,0.1)":"rgba(99,102,241,0.15)", marginTop:3 }}>
                    <div style={{ width:`${Math.min(100,(cnt/Math.max(1,top5[0][1]))*100)}%`, height:"100%", borderRadius:2, background:COLORS[i]||"var(--accent)" }}/>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 후기 목록 */}
      <div style={{ marginBottom:14 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:12 }}>
          <div style={{ fontSize:13, fontWeight:800, color:"var(--text)" }}>✍️ 여행자 후기 <span style={{ fontSize:11, color:dm?"rgba(226,232,240,0.60)":"rgba(51,65,85,0.55)", fontWeight:600 }}>({reviews.length}개)</span></div>
          {reviews.length > 0 && (
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {["전체", ...Object.keys(destCount).slice(0,5)].map(d=>(
                <button key={d} onClick={()=>{ setFilterDest(d); setReviewPage(0); }}
                  style={{ padding:"3px 10px", borderRadius:100, border:`1px solid ${filterDest===d?"var(--accent)":dm?"rgba(129,140,248,0.2)":"rgba(99,102,241,0.22)"}`, background:filterDest===d?"var(--accent)":dm?"rgba(255,255,255,0.05)":"rgba(255,255,255,0.8)", color:filterDest===d?"#fff":"var(--text)", fontSize:10, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>
                  {d==="전체"?"🌐 전체":getEmoji(d)+" "+d}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {reviews.length === 0 ? (
        <div style={{ textAlign:"center", padding:"40px 20px" }}>
          <div style={{ fontSize:44, marginBottom:12 }}>{authRequired ? "🔒" : "✍️"}</div>
          <p style={{ fontSize:13, fontWeight:700, color:"var(--text)", marginBottom:4 }}>
            {authRequired ? "로그인하면 여행자 후기를 볼 수 있어요" : "아직 등록된 후기가 없어요"}
          </p>
          <p style={{ fontSize:11, color:dm?"rgba(226,232,240,0.65)":"rgba(51,65,85,0.60)" }}>
            {authRequired ? "후기에는 작성자의 여행 기록이 담겨 있어 회원에게만 공개합니다." : "여행 일정을 완성하고 첫 후기를 남겨보세요!"}
          </p>
        </div>
      ) : (() => {
        const filtered = filterDest==="전체" ? reviews : reviews.filter(r=>r.destination&&r.destination.includes(filterDest));
        const totalPages = Math.ceil(filtered.length / REVIEWS_PER_PAGE);
        const pageReviews = filtered.slice(reviewPage * REVIEWS_PER_PAGE, (reviewPage + 1) * REVIEWS_PER_PAGE);
        return (
          <>
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {pageReviews.map((r,idx)=>{
                const isMe = r.author === (myName||personal?.name);
                return (
                  <div key={r.id||idx} style={{ borderRadius:16, border:`1.5px solid ${isMe?dm?"rgba(129,140,248,0.35)":"rgba(99,102,241,0.35)":dm?"rgba(129,140,248,0.12)":"rgba(99,102,241,0.15)"}`, background:isMe?dm?"rgba(129,140,248,0.07)":"rgba(255,248,220,0.7)":dm?"rgba(255,255,255,0.04)":"rgba(255,255,255,0.84)", overflow:"hidden" }}>
                    {isMe && <div style={{ background:`linear-gradient(90deg,var(--accent),#E8935A)`, padding:"4px 14px" }}><span style={{ fontSize:10, fontWeight:800, color:"#fff" }}>✦ 내 후기</span></div>}
                    <div style={{ padding:"14px 16px" }}>
                      <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:8 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:9 }}>
                          <div style={{ width:36, height:36, borderRadius:"50%", background:`linear-gradient(135deg,var(--accent),var(--teal))`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:15, flexShrink:0, color:"#fff", fontWeight:800 }}>
                            {r.author?.charAt(0)||"?"}
                          </div>
                          <div>
                            <div style={{ fontSize:12, fontWeight:800, color:"var(--text)" }}>{r.author?.charAt(0)+"*".repeat(Math.max((r.author?.length||1)-1,1))}</div>
                            <div style={{ fontSize:10, color:dm?"rgba(226,232,240,0.65)":"rgba(51,65,85,0.62)" }}>📍{r.destination} · {r.createdAt}</div>
                          </div>
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:4 }}>
                          <span style={{ fontSize:13 }}>{"⭐".repeat(r.rating)}</span>
                          {isMe && onDeleteReview && <button onClick={()=>onDeleteReview(r.id)} style={{ background:"transparent", border:"none", fontSize:13, cursor:"pointer", color:dm?"rgba(226,232,240,0.55)":"rgba(200,60,45,0.45)", padding:"0 0 0 4px" }}>🗑️</button>}
                        </div>
                      </div>
                      <div style={{ fontSize:13, fontWeight:800, color:"var(--accent)", marginBottom:5, }}>"{r.title}"</div>
                      <div style={{ fontSize:12, color:dm?"rgba(226,232,240,0.78)":"rgba(51,65,85,0.80)", lineHeight:1.75, marginBottom:r.scores&&Object.values(r.scores).some(v=>v>0)?8:0 }}>{r.content}</div>
                      {r.scores && Object.values(r.scores).some(v=>v>0) && (
                        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:8 }}>
                          {[{key:"food",label:"🍽 음식"},{key:"stay",label:"🏨 숙박"},{key:"sight",label:"🗺 관광"},{key:"move",label:"🚌 이동"}].filter(it=>r.scores[it.key]>0).map(it=>(
                            <span key={it.key} style={{ fontSize:10, padding:"2px 8px", borderRadius:100, background:dm?"rgba(129,140,248,0.10)":"rgba(238,242,255,0.95)", border:"1px solid rgba(99,102,241,0.25)", color:"var(--accent)", fontWeight:700 }}>
                              {it.label} {"★".repeat(r.scores[it.key])}
                            </span>
                          ))}
                        </div>
                      )}
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:6 }}>
                        <div>
                          {isMe && onEditReview && (
                            <button onClick={()=>onEditReview(r)} style={{ padding:"4px 10px", borderRadius:7, border:`1px solid ${dm?"rgba(129,140,248,0.3)":"rgba(99,102,241,0.3)"}`, background:dm?"rgba(129,140,248,0.08)":"rgba(255,248,220,0.9)", color:"var(--accent)", fontSize:10, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}>✏️ 수정</button>
                          )}
                        </div>
                        <button style={{ display:"flex", alignItems:"center", gap:4, padding:"5px 12px", borderRadius:20, border:`1px solid ${dm?"rgba(99,102,241,0.2)":"rgba(99,102,241,0.18)"}`, background:"transparent", cursor:"pointer", fontSize:11, color:dm?"rgba(226,232,240,0.80)":"rgba(71,85,105,0.6)", fontWeight:700, fontFamily:"inherit" }}>
                          👍 {r.likes>0?r.likes:""}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* 페이지네이션 */}
            {totalPages > 1 && (
              <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginTop:20 }}>
                <button onClick={()=>setReviewPage(p=>Math.max(0,p-1))} disabled={reviewPage===0}
                  style={{ width:36, height:36, borderRadius:10, border:`1px solid ${dm?"rgba(129,140,248,0.25)":"rgba(99,102,241,0.25)"}`, background:reviewPage===0?dm?"rgba(255,255,255,0.03)":"rgba(0,0,0,0.04)":"transparent", color:reviewPage===0?dm?"rgba(226,232,240,0.3)":"rgba(51,65,85,0.3)":"var(--accent)", fontSize:16, cursor:reviewPage===0?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"inherit", transition:"all 0.2s" }}>&#8249;</button>
                {Array.from({length:totalPages},(_,i)=>(
                  <button key={i} onClick={()=>setReviewPage(i)}
                    style={{ width:36, height:36, borderRadius:10, border:`1px solid ${reviewPage===i?"var(--accent)":dm?"rgba(129,140,248,0.2)":"rgba(99,102,241,0.2)"}`, background:reviewPage===i?"var(--accent)":"transparent", color:reviewPage===i?"#fff":"var(--text)", fontSize:13, fontWeight:800, cursor:"pointer", fontFamily:"inherit", transition:"all 0.2s" }}>{i+1}</button>
                ))}
                <button onClick={()=>setReviewPage(p=>Math.min(totalPages-1,p+1))} disabled={reviewPage===totalPages-1}
                  style={{ width:36, height:36, borderRadius:10, border:`1px solid ${dm?"rgba(129,140,248,0.25)":"rgba(99,102,241,0.25)"}`, background:reviewPage===totalPages-1?dm?"rgba(255,255,255,0.03)":"rgba(0,0,0,0.04)":"transparent", color:reviewPage===totalPages-1?dm?"rgba(226,232,240,0.3)":"rgba(51,65,85,0.3)":"var(--accent)", fontSize:16, cursor:reviewPage===totalPages-1?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"inherit", transition:"all 0.2s" }}>&#8250;</button>
              </div>
            )}
          </>
        );
      })()}
    </GlassCard>
  );
}
